@if (src()) {
  <img 
    [ngSrc]="src()!" 
    [alt]="alt()" 
    [style]="imgStyle()" 
    [title]="title()"
    [class]="imgClass()" 
    [sizes]="sizes()" 
    [loading]="loading()"
    [priority]="priority()"
    [attr.crossorigin]="crossOrigin()"
    [fill]="useFill()"
    [placeholder]="usePlaceholder()"
    [loaderParams]="{filters: 'quality(' + quality() + ')', repo: repo()}" />
}
